import React, { useState, useEffect } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { Modal } from 'rsuite'
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import { markListComplete, getListDataById, getListSuppliers, getListCardableSpend } from '../../../redux/actions/vendor';
import CheckboxComponent from '../../CommonComponents/CheckboxComponent'
import { getAbbreviatedState } from '../../../services/helper';
import LoaderComponent from '../../CommonComponents/LoaderComponent';
import { toast } from '../../CommonComponents/ToastComponent/toast';

const MarkCompleteModal = ({ show, onClose, listInfo }) => {
    const store = useStore().getState()
    const {
        app: {
            supplierAllColumns
        }
    } = store
    const dispatch = useDispatch()
    const [isSendToSequencing, setIsSendToSequencing] = useState(false)
    const [isMarkingListComplete, setIsMarkingListComplete] = useState(false)
    const [listData, setListData] = useState({})
    const [listSuppliers, setListSuppliers] = useState([])

    useEffect(() => {
        dispatch(getListDataById(listInfo?.id)).then(async (res) => {
            let cardableSpend = await dispatch(getListCardableSpend(listInfo?.id)).then(spend => {
                let totalCardableSpend = 0
                spend?.listSups?.length && spend?.listSups.map(matchedSup => {
                    if (matchedSup?.spend) {
                        let supplier = spend?.allSuppliers.find((sup) => matchedSup?.matchedSupplierId === sup?.id);
                        if (supplier && supplier?.masterId) {
                            supplier = spend?.allSuppliers.find((sup) => supplier?.masterId === sup?.id);
                        }
                        if (supplier && (supplier?.cardAcceptance?.isAcceptAmericanExpress || supplier?.cardAcceptance?.isAcceptVisa || supplier?.cardAcceptance?.isAcceptMasterCard)) {
                            totalCardableSpend = totalCardableSpend + parseFloat(matchedSup?.spend);
                        }
                    }
                })
                return totalCardableSpend
            })
            cardableSpend = '$ ' + (cardableSpend ? Number(Math.round(cardableSpend)).toLocaleString() : cardableSpend)
            setListData({ ...res?.list, totalCardableSpend: cardableSpend > 0 ? cardableSpend.toFixed(2) : cardableSpend })
        }).catch(() => {
            setListData({})
        })
        dispatch(getListSuppliers({
            listId: listInfo?.id,
            type: 'full',
            limit: null,
            offset: null,
            sortColumn: "suppliername",
            sortType: "asc",
            isMarkListComplete: true,
            isGetAllColumns: true
        })).then(res => {
            setListSuppliers(res?.listSuppliers)
        })
    }, [])

    const handleYesClick = async () => {
        if (!listSuppliers || listSuppliers?.length === 0) {
            toast.show({
                title: 'Warning',
                description: 'No List Suppliers found to mark as complete!',
            })
            return
        }
        if (isSendToSequencing) {
            onClose(false, isSendToSequencing)
        } else {
            setIsMarkingListComplete(true)
            const tmpData = await listSuppliers.map(row => {
                const tmpSupplierData = {}
                supplierAllColumns.forEach(column => {
                    if (column.name === 'autoCreateMaster') {
                        return
                    }
                    if (column.name === 'state') {
                        tmpSupplierData[column.name] = row[column.name]
                        let stateCode = getAbbreviatedState(row?.abbreviatedState, row?.state)
                        tmpSupplierData['abbreviatedState'] = stateCode
                    } else {
                        tmpSupplierData[column.name] = row[column.name]
                    }
                })
                tmpSupplierData['matchedSupplierId'] = row?.matchedSupplierId
                tmpSupplierData['listSupplierId'] = row?.id
                tmpSupplierData['isInCalls'] = row?.isInCalls
                tmpSupplierData['QaTime'] = row?.QaTime || null
                return tmpSupplierData
            })

            dispatch(markListComplete(listData?.id, tmpData)).then(() => {
                setIsMarkingListComplete(false)
                onClose(true)
            }).catch(() => {
                setIsMarkingListComplete(false)
            })
        }
    }

    let matchedSuppliers = listSuppliers?.length ? listSuppliers.filter(sup => sup?.matchedSupplierId) : []
    let qaVendors = matchedSuppliers?.length ? matchedSuppliers.filter(sup => sup?.approvedByManager === null) : []
    let qaApproved = matchedSuppliers?.length - qaVendors?.length

    return (
        <div>
            <Modal
                backdrop='static'
                className="qa-list-modal"
                show={show}
                size="lg"
                onClick={() => { onClose() }}
                onHide={() => { onClose() }}
            >
                <Modal.Header>
                    <h3 className='fw-bold text-black mb-0'> Mark List as Complete </h3>
                </Modal.Header>
                <Modal.Body className={`mt-3 ${(isMarkingListComplete || Object.keys(listData)?.length === 0) ? 'loading' : ''}`}>
                    <div className='header d-flex mb-4'>
                        <h3 className='text-blue mb-0'>{listData?.partnerName}</h3>
                    </div>
                    {(isMarkingListComplete || Object.keys(listData)?.length === 0) && <LoaderComponent />}
                    <div className='border border-2 rounded p-4'>
                        <div className='row'>
                            <div className='col-6 d-flex align-items-center gap-3'>
                                <h4 className='w-50'> Company Name </h4>
                                <input className='search-input' value={listData?.companyName} disabled={true} />
                            </div>
                            <div className='col-6 d-flex align-items-center gap-3'>
                                <h4 className='w-50'> Contact Name </h4>
                                <input className='search-input' value={listData?.primaryContact} disabled={true} />
                            </div>
                        </div>
                        <div className='row mt-4'>
                            <div className='col-6 d-flex align-items-center gap-3'>
                                <h4 className='w-50'> Company Phone </h4>
                                <div className="w-100 flex align-center flex-grow-1">
                                    <div className='d-flex border border-1 rounded phone-input-ext-container w-100 flex-column flex-lg-row'>
                                        <ReactPhoneInput
                                            className='phone-input-parent'
                                            country={'us'}
                                            value={listData?.contactPhone}
                                            countryCodeEditable={false}
                                            preferredCountries={['us']}
                                            disabled={true}
                                            buttonClass='border-0 border-end'
                                            inputProps={{
                                                className: 'form-control border-0'
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='col-6 d-flex align-items-center gap-3'>
                                <h4 className='w-50'> Contact Email </h4>
                                <input className='search-input' value={listData?.contactEmail} disabled={true} />
                            </div>
                        </div>
                    </div>
                    <div className='border border-2 rounded p-4 mt-5'>
                        <div className='row'>
                            <div className='col-6 d-flex align-items-center gap-3'>
                                <h4 className='w-50'> Suppliers </h4>
                                <input className='search-input' value={listSuppliers?.length} disabled={true} />
                            </div>
                            <div className='col-6 d-flex align-items-center gap-3'>
                                <h4 className='w-50'> Suppliers Matched </h4>
                                <input className='search-input' value={(listData?.suppliersMatched || 0) || (matchedSuppliers?.length || 0)} disabled={true} />
                            </div>
                        </div>
                        <div className='row mt-4'>
                            <div className='col-6 d-flex align-items-center gap-3'>
                                <h4 className='w-50'> AP Spend </h4>
                                <input className='search-input' value={listInfo?.totalApSpend || 0} disabled={true} />
                            </div>
                            <div className='col-6 d-flex align-items-center gap-3'>
                                <h4 className='w-50'> Cardable Spend </h4>
                                <input className='search-input' value={listData?.totalCardableSpend || 0} disabled={true} />
                            </div>
                        </div>
                        <div className='row mt-4'>
                            <div className='col-6 d-flex align-items-center gap-3'>
                                <h4 className='w-50'> QA Approved </h4>
                                <input className='search-input' value={qaApproved} disabled={true} />
                            </div>
                            <div className='col-6 d-flex align-items-center gap-3'>
                                <h4 className='w-50'> QA Pending </h4>
                                <input className='search-input' value={qaVendors?.length} disabled={true} />
                            </div>
                        </div>
                        <div className='row mt-4'>
                            <div className='col-6 d-flex align-items-center gap-3'>
                                <h4 className='w-50'> Date Imported </h4>
                                <input className='search-input' value={listData?.dateSubmitted} disabled={true} />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className='d-flex justify-content-end align-items-center'>
                    <CheckboxComponent
                        label='Send to Sequencing'
                        checked={isSendToSequencing}
                        onChange={(checked) => { setIsSendToSequencing(checked) }}
                        disabled={isMarkingListComplete || Object.keys(listData)?.length === 0}
                    />
                    <div className='ms-5'>
                        <button className='bg-green h4 mb-0 rounded text-white p-5 pt-3 pb-3' disabled={isMarkingListComplete || Object.keys(listData)?.length === 0} onClick={() => { handleYesClick() }}> Yes </button>
                        <button className='bg-red h4 mb-0 rounded text-white ms-4 p-5 pt-3 pb-3' disabled={isMarkingListComplete || Object.keys(listData)?.length === 0} onClick={() => { onClose() }}> No </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div >
    )
}

export default MarkCompleteModal